class RemainingChars {

    protected initialized: boolean = false;

    // selectorPrefix param is a css selector string to initialize just certain remaining chars element
    public initOnce(forceInit: boolean = false, selectorPrefix: string = ''): void {

        if (this.initialized && !forceInit) {
            return;
        }
        this.initialized = true;

        $(function () {
            const $elements = $(`${selectorPrefix} textarea[data-limit][data-limit-div][data-limit-label], ${selectorPrefix} input[data-limit][data-limit-div][data-limit-label]`);
            $.each($elements, function () {
                const $limitChars = $(`${selectorPrefix} #${$(this).data('limit-div')}`);
                const limit = $(this).data('limit');
                const initialLimit = limit - (<string>$(this).val()).length;

                $limitChars.html(`${$(this).data('limit-label')} ${initialLimit}`);

                $(this).on('input', function (this: HTMLInputElement) {
                    const textlength = this.value.length;

                    const limitCharsText = $(this).data('limit-label') + ' ' + (Math.max(limit - textlength, 0));

                    if (textlength > limit) {
                        this.value = this.value.slice(0, limit);
                    }

                    $limitChars.html(limitCharsText);

                    return textlength <= limit;
                });
            });
        });
    }
}

export default new RemainingChars();